import { render, staticRenderFns } from "./authLayout.vue?vue&type=template&id=120aebf8&"
import script from "./authLayout.vue?vue&type=script&lang=js&"
export * from "./authLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports